import React from 'react';

interface RankButtonProps {
  value: number;
  className?: string;
  rankType: 'cumulative';
  isDefaultValue?: boolean;
}

const RankButton: React.FC<RankButtonProps> = ({ value, className = "", rankType, isDefaultValue = false }) => {
  const getTargetPercentStyle = (percent: number) => {
    if (percent > 10) {
      return 'text-red-400';
    } else if (percent > 2) {
      return 'text-amber-400';
    } else {
      return 'text-green-400';
    }
  };

  const buttonContent = (
    <span 
      className={`text-[14px] font-medium cursor-pointer px-1 py-0.5 rounded hover:bg-gray-700 transition-colors ${isDefaultValue ? 'text-gray-500' : getTargetPercentStyle(value)} ${className}`}
    >
      {isDefaultValue ? '-' : `${value}`}<span className="text-[10px]">%</span>
    </span>
  );

  return (
    buttonContent
  );
};

export default RankButton; 